import React, { useState, useEffect, useRef } from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [visibleSections, setVisibleSections] = useState([]);
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsFooterVisible(true);
            // Stagger section animations
            [0, 1, 2, 3].forEach((index) => {
              setTimeout(() => {
                setVisibleSections((prev) => [...prev, index]);
              }, index * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className={`footer ${isFooterVisible ? 'visible' : ''}`} ref={footerRef}>
      <div className="container">
        <div className="footer-content">
          <div className={`footer-section ${visibleSections.includes(0) ? 'visible' : ''}`}>
            <h3>STOREZI</h3>
            <p className="footer-tagline">
              We design Shopify stores that don't just look good, they are built to sell.
              Transform your e-commerce vision into reality.
            </p>
            <div className="social-links">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
            </div>
          </div>

          <div className={`footer-section ${visibleSections.includes(1) ? 'visible' : ''}`}>
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('hero')}>Home</button></li>
              <li><button onClick={() => scrollToSection('projects')}>Projects</button></li>
              <li><button onClick={() => scrollToSection('services')}>Services</button></li>
              <li><button onClick={() => scrollToSection('process')}>Process</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className={`footer-section ${visibleSections.includes(2) ? 'visible' : ''}`}>
            <h4>Services</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('services')}>Custom Store Design</button></li>
              <li><button onClick={() => scrollToSection('services')}>Store Redesign</button></li>
              <li><button onClick={() => scrollToSection('services')}>Optimization</button></li>
              <li><button onClick={() => scrollToSection('services')}>Support</button></li>
            </ul>
          </div>

          <div className={`footer-section ${visibleSections.includes(3) ? 'visible' : ''}`}>
            <h4>Address</h4>
            <address className="footer-address">
              StoreZi, a DBA of Flow Technologies Inc.<br />
              3200 Wilcrest Drive, Suite 575<br />
              Houston, TX 77042
            </address>
            <h4>Contact</h4>
            <ul className="footer-contact">
              <li>
                <a href="mailto:hello@storezi.app">hello@storezi.app</a>
              </li>
              <li>
                <a href="http://www.storezi.app" target="_blank" rel="noopener noreferrer">
                  www.storezi.app
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} STOREZI. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
